import storage from 'common/services/storage'
import sessionStorage from 'common/services/sessionStorage'

export const ACCESS_TOKEN_KEY = 'pico_token'
export const REFRESH_TOKEN_KEY = 'pico_refresh_token'

export function saveToken(message, token) {
    if (token) {
        if (message === 'TOKEN/STORE/REFRESH') {
            storage.set(REFRESH_TOKEN_KEY, token)
        } else if (message === 'TOKEN/STORE/ACCESS') {
            storage.set(ACCESS_TOKEN_KEY, token)
        }
    }
}

export function removeToken(message) {
    if (message === 'TOKEN/REMOVE/ACCESS') {
        storage.remove(ACCESS_TOKEN_KEY)
    } else if (message === 'TOKEN/REMOVE/REFRESH') {
        storage.remove(REFRESH_TOKEN_KEY)
    }
}

export function getRefreshToken() {
    const refresh_token = storage.get(REFRESH_TOKEN_KEY)

    if (!refresh_token) {
        return null
    }

    return refresh_token.replace(/['"]+/g, '')
}

export function getAccessToken() {
    const access_token = storage.get(ACCESS_TOKEN_KEY)

    if (!access_token) {
        return null
    }

    return access_token.replace(/['"]+/g, '')
}

// These methods specifically hit sessionStorage instead of storage
// because sessions need to be expired naturally by the browser. If
// we use the regular store, we may end up with session data stuck
// in localStorage, for example, and not actually being removed until
// the user explicitly clears their data for the site.
export function getSession() {
    try {
        return sessionStorage.get('session-id')
    } catch (e) {
        return null
    }
}

export function setSession(sessionId) {
    try {
        return sessionStorage.set('session-id', sessionId)
    } catch (e) {
        return false
    }
}
